import * as _ from 'lodash';
const getEnvValue = (key, prefix = '') => {
    const keyVal = `${prefix}${key}`;
    const strVal = process.env[keyVal];
    return strVal;
};
function getValueOrDefault(key, prefix, getValue) {
    return (defaultValue) => {
        const keyVal = `${prefix}${key}`;
        const strVal = process.env[keyVal];
        const envVal = getValue ? getValue(strVal) : strVal;
        return _.isNil(envVal) ? defaultValue : envVal;
    };
}
const value = (key, getValue) => getValueOrDefault(key, '', getValue);
const isTrue = (value) => (value && ['1', 'true', 'True', 'TRUE', 'yes'].includes(value) ? true : false);
export const ConfigUtils = {
    value,
    getValueOrDefault,
    getEnvValue,
    isTrue,
};
//# sourceMappingURL=config.js.map